import React from "react";

export default function CodeViewer(props) {
  return (
    <code className="block whitespace-pre-wrap border p-6 rounded bg-code-block text-white">
      {props.children}
    </code>
  );
}
